import React from 'react';
import I18n from 'i18n-js';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import Currency from '@reverbdotcom/commons/src/currency';
import { LANGUAGES } from './shared/constants';
import LocalePickerButton from './locale_picker/locale_picker_button';

export default function FooterLocalePicker() {
  const { locale, currency, shippingRegionCode } = useUser();
  const language = LANGUAGES[locale];

  return (
    <LocalePickerButton className="locale-switcher">
      <span>
        {I18n.t(`discovery.shippingRegions.${shippingRegionCode}`)}
      </span>
      <span>
        {language}
      </span>
      <span>
        {`${Currency.get(currency).symbol} ${currency}`}
      </span>
    </LocalePickerButton>
  );
}
